import states from '@/helpers/brazilianStates.json';

const directRelationships = {
  name: 'nome',
  phone: 'telefone',
  profession: 'profissao',
  nationality: 'nacionalidade',
  cep: 'cep',
  cpf: 'documentoNumero',
  address: 'endereco',
  addressNumber: 'enderecoNumero',
  addressComplement: 'complemento',
  countryName: 'pais',
  countryCode: 'codigoPais',
  stateName: 'estado',
  stateCode: 'codigoEstado',
  cityName: 'cidade',
  cityCode: 'codigoCidade',
  isMainGuest: 'isHospedePrincipal',
  contactOptin: 'aceitouConsentimento',
  consentText: 'textoConsentimento',
};

const apiIntegrationBaseUrl =
  'https://hub.letsbook.com.br/webcheckin/guest-reservation';

const handleGet = (data) => {
  const mergedData = { ...data };

  Object.entries(directRelationships).forEach(([formKey, dataKey]) => {
    delete mergedData[dataKey];
    mergedData[formKey] = data[dataKey];
  });

  if (data.nome) {
    const [name, ...surname] = data.nome.split(' ');
    mergedData.name = name;
    mergedData.surname = surname.join(' ');
  }

  if ([2, 'cpf'].includes(data.documento)) {
    mergedData.cpf = data.documentoNumero;
  }

  if (data.documento === 'PASSAPORTE') {
    mergedData.nationality = 'Outra';
  } else if (!data.nacionalidade) {
    mergedData.nationality = 'BR';
  }

  if (!data.codigoPais) {
    if (!data.pais || data.pais.toLowerCase() === 'brasil') {
      mergedData.countryCode = 'BR';
    } else if (data.pais.length === 2) {
      mergedData.countryCode = data.pais;
    }
  }

  if (data.cep && /^\d{8}$/.test(data.cep)) {
    mergedData.cep = `${data.cep.substring(0, 5)}-${data.cep.substring(5)}`;
  }

  if (!data.codigoEstado) {
    mergedData.stateCode = '';
  }

  if (!data.estado) {
    mergedData.stateName = '';
  }

  if (data.dataNascimento) {
    delete mergedData.dataNascimento;
    mergedData.birthDate = data.dataNascimento
      .substring(0, 10)
      .split('-')
      .reverse()
      .join('/');
  }

  // transformar em boolean false se for null.
  // não tratamos com !! pois caso seja enviado seria "0" ou "1" (ambos true)
  if (!data.aceitouConsentimento) {
    mergedData.contactOptin = false;
  }

  return mergedData;
};

export const getData = (mainGuest, { travelHubToken, travelHubHotelCode }) => {
  const checkInDate = mainGuest.checkInDate.split('/').reverse().join('-');

  const endpoint = `${apiIntegrationBaseUrl}?Checkin=${checkInDate}&ReservationCode=${mainGuest.reservationCode}&Surname=${mainGuest.surname}`;

  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    travelHubToken,
  };

  if (travelHubHotelCode) {
    headers.travelHubHotelCode = travelHubHotelCode;
  }

  return fetch(endpoint, {
    method: 'GET',
    headers,
  })
    .then((res) => res.json())
    .then(({ reservationType, origin, data }) => {
      if (!data || !data.length) {
        throw new Error('Reserva não encontrada');
      }

      return {
        reservationType,
        origin,
        guests: data.map(handleGet),
      };
    });
};

const handleSubmition = (data, origin) => {
  const mergedData = { ...data };

  Object.entries(directRelationships).forEach(([formKey, dataKey]) => {
    delete mergedData[formKey];
    mergedData[dataKey] = data[formKey];
  });

  delete mergedData.reservationCode;

  delete mergedData.surname;
  mergedData.nome = `${data.name} ${data.surname}`;

  if (mergedData.nacionalidade === 'BR') {
    mergedData.documento = 'cpf';
  } else if (origin === 'Letsbook') {
    mergedData.documento = 'PASSAPORTE';
  } else {
    mergedData.documento = 2;
  }

  if (origin === 'Letsbook') {
    const stateObj = states.find((state) => data.stateCode === state.code);
    mergedData.estado = stateObj ? stateObj.name : data.stateCode;
  }

  mergedData.dataNascimento = `${data.birthDate
    .split('/')
    .reverse()
    .join('-')}T00:00:00`;

  if (data.consentText) {
    mergedData.aceitouConsentimento = data.contactOptin ? '1' : '0';
  } else {
    delete mergedData.aceitouConsentimento;
    delete mergedData.textoConsentimento;
  }

  return mergedData;
};

export const submitData = (
  guests,
  { reservationType, origin, travelHubToken, travelHubHotelCode },
) => {
  const { reservationCode } =
    guests.find(({ isMainGuest }) => isMainGuest) || guests[0];

  const integrationGuests = guests.map((guest) =>
    handleSubmition(guest, origin),
  );

  const body = {
    reservationCode,
    reservationType,
    guests: [...integrationGuests],
  };

  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    travelHubToken,
    travelHubOrigin: origin,
  };

  if (travelHubHotelCode) {
    headers.travelHubHotelCode = travelHubHotelCode;
  }

  return fetch(apiIntegrationBaseUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
};

export const submitEmail = (body, apiBaseUrl, customer) => {
  return fetch(`${apiBaseUrl}preCheckIn/${customer}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(body),
  });
};
